<template>
    <div class="check-list">
        <template v-if="loading">
            <CompassSkeleton v-for="item in items" :key="item.id" size="x-large" />
        </template>
        <template v-else>
            <CheckListItem v-for="item in items" :key="item.id" v-bind="item" />
        </template>
    </div>
</template>
<script>
import CheckListItem from 'vcomponents/common/CheckList/CheckListItem/CheckListItem.vue';
export default {
    components: {
        CheckListItem,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.check-list {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
}
</style>
